import { apiFetch } from "@/api/client";

/**
 * JSON Schema passthrough (ADR-0040 `GET /api/v1/schema/{name}`).
 *
 * The backend serializes with `by_alias=true`, so the field is `schema`
 * (Pydantic's `schema_` alias). The `schema` value is a Pydantic-generated JSON
 * Schema object; we only read `required` + `title` for authoring hints, so it is
 * loosely typed here.
 */
export interface JsonSchema {
  title?: string;
  required?: string[];
  properties?: Record<string, unknown>;
  [k: string]: unknown;
}

export interface SchemaResponse {
  name: string;
  schema: JsonSchema;
}

export function getSchema(name: string): Promise<SchemaResponse> {
  return apiFetch<SchemaResponse>(`/api/v1/schema/${encodeURIComponent(name)}`);
}
